import { z } from 'zod';

export const userSessionRepResDto = z.object({
  id: z.string(),
  // we only parse the required fields
});
